
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M10.5 8.99996H13.5C13.78 8.99996 14 8.77996 14 8.49996V5.99996H15.79C16.24 5.99996 16.46 5.45996 16.14 5.14996L12.35 1.35996C12.15 1.15996 11.84 1.15996 11.64 1.35996L7.85001 5.14996C7.54001 5.45996 7.76001 5.99996 8.21001 5.99996H10V8.49996C10 8.77996 10.22 8.99996 10.5 8.99996ZM8.50001 9.99996H6.00001V8.20996C6.00001 7.75996 5.46001 7.53996 5.15001 7.85996L1.36001 11.65C1.16001 11.85 1.16001 12.16 1.36001 12.36L5.15001 16.15C5.46001 16.46 6.00001 16.24 6.00001 15.79V14H8.50001C8.78001 14 9.00001 13.78 9.00001 13.5V10.5C9.00001 10.22 8.78001 9.99996 8.50001 9.99996ZM22.65 11.65L18.86 7.85996C18.54 7.53996 18 7.75996 18 8.20996V9.99996H15.5C15.22 9.99996 15 10.22 15 10.5V13.5C15 13.78 15.22 14 15.5 14H18V15.79C18 16.24 18.54 16.46 18.85 16.14L22.64 12.35C22.84 12.16 22.84 11.84 22.65 11.65ZM13.5 15H10.5C10.22 15 10 15.22 10 15.5V18H8.21001C7.76001 18 7.54001 18.54 7.86001 18.85L11.65 22.64C11.85 22.84 12.16 22.84 12.36 22.64L16.15 18.85C16.46 18.54 16.24 18 15.8 18H14V15.5C14 15.22 13.78 15 13.5 15Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-open-with`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconOpenWith

    ```js
    <b-new-b-icon-open-with />
    ```
</docs>


